"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@clayui/core");

var _react = _interopRequireWildcard(require("react"));

var _DropDownContext = require("./DropDownContext");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var Collection = _core.__NOT_PUBLIC_COLLECTION.Collection;
var counter = 0;

function ClayDropDownGroup(_ref) {
  var children = _ref.children,
      header = _ref.header,
      items = _ref.items,
      _ref$role = _ref.role,
      role = _ref$role === void 0 ? 'group' : _ref$role;
  var ariaLabel = (0, _react.useMemo)(function () {
    counter++;
    return "clay-dropdown-menu-group-".concat(counter);
  }, []);

  var _useContext = (0, _react.useContext)(_DropDownContext.DropDownContext),
      search = _useContext.search;

  var filterFn = (0, _react.useCallback)(function (value) {
    return value.match(new RegExp(search, 'i')) !== null;
  }, [search]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, header && /*#__PURE__*/_react.default.createElement("li", {
    "aria-hidden": "true",
    className: "dropdown-subheader",
    id: ariaLabel,
    role: "presentation"
  }, header), /*#__PURE__*/_react.default.createElement("li", {
    role: "presentation"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    "aria-labelledby": ariaLabel,
    className: "list-unstyled",
    role: role
  }, /*#__PURE__*/_react.default.createElement(Collection, {
    filter: filterFn,
    filterKey: "textValue",
    items: items,
    passthroughKey: false
  }, children))));
}

ClayDropDownGroup.displayName = 'Group';
var _default = ClayDropDownGroup;
exports.default = _default;